export enum Attributes {
    LogicJump = 'logicJump',
    InlineResponse = 'inlineResponse',
    Media = 'media',
}
